import { RootState } from '../types'

export const getBrandSelector = (state: RootState) => state.brand
